import * as mobx from 'mobx';
import { IEventDetailsDTO } from '../../../../../../api/events.dao';
import { IScheduledEmailDTO, IScheduledEmailsListDTO, ITrackingEmailValues, ScheduledTypes } from '../../../../../../api/scheduled-email.dao';
import { ISubWindowFacade } from '../../../../../../infrastructure/sub-windows';
import { TObject } from '../../../../../../infrastructure/type-extensions';
import { ScheduledMeetingEmailPopupViewmodel } from './_new-scheduled-meeting-email-popup/scheduled-meeting-email-popup.viewmodel';
import { ScheduledEmailsFormBaseVM } from './scheduled-emails-form-base.viewmodel';
import { IMeetingData } from './scheduled-email-form/scheduled-email-form.viewmodel';
import { capitalizeFirstLetter } from '../../../../../../infrastructure/utils/string.utils';
import { ScheduledEmailForm } from './scheduled-email-form/scheduled-email-form';
import { CONFIGURE_EMAIL_TEXT } from './scheduled-emails-form.texts';
import { AttendeeRole } from '../../../../../../api/attendees.dao';

class ScheduledMeetingsEmailsVM extends ScheduledEmailsFormBaseVM {
    public readonly type: ScheduledTypes = ScheduledTypes.Meeting;
    @mobx.observable
    private scheduledMeetingEmailPopupViewmodel: ScheduledMeetingEmailPopupViewmodel;

    constructor(
        protected accountId: number,
        protected _event: IEventDetailsDTO,
        meetingEmails: IScheduledEmailsListDTO,
        emailIdToEditPopupMap: TObject<ISubWindowFacade>,
    ) {
        super(accountId, _event, meetingEmails, emailIdToEditPopupMap);
        this.scheduledMeetingEmailPopupViewmodel = new ScheduledMeetingEmailPopupViewmodel(this.showScheduledEmailForm);
    }

    public get scheduledMeetingPopupVM(): ScheduledMeetingEmailPopupViewmodel {
        return this.scheduledMeetingEmailPopupViewmodel;
    }

    public onEditAction = (id: string): void => {
        const email = super.findEmailById(id) as IScheduledEmailDTO;
        this.scheduledMeetingEmailPopupViewmodel.openEditPopUp(id, email.meetingId, email.roles);
    };

    public onCreateAction = (): void => {
        this.scheduledMeetingEmailPopupViewmodel.openPopUp();
    };

    protected openNewSubWindow(id: string): void {
        const facade = this.subWindowsService.showSubWindow({
            withExpand: true,
            isExpandedByDefault: true,
            title: this.intl.formatMessage(CONFIGURE_EMAIL_TEXT),
            componentToHost: ScheduledEmailForm,
            componentToHostProps: {
                saveCompletionCallback: super.onSaveCompleted,
                updateCompletionCallback: super.onUpdateCompleted,
                accountId: this.accountId,
                event: this.event,
                type: this.type,
                scheduledEmailDTO: super.findEmailById(id),
                meetingData: this.getMeetingData()
            },
        });

        if (id) super.setEmailIdToEditPopupMap(id, facade);
    };

    protected emailTrackingData = (dateTime: Date, meetingId: number): ITrackingEmailValues => {
        return {
            ...super.emailTrackingData(dateTime, meetingId),
            'Email Type': capitalizeFirstLetter(this.type),
            'Roles' : this.scheduledMeetingEmailPopupViewmodel.roles.join(', ')
        };
    };

    private getMeetingData = (): IMeetingData => {
        const meetingId = this.scheduledMeetingEmailPopupViewmodel.meetingId;

        return {
            ...this.scheduledMeetingEmailPopupViewmodel.getMeetingById(meetingId),
            roles: this.scheduledMeetingEmailPopupViewmodel.roles.map(x => capitalizeFirstLetter(x) as AttendeeRole),
        };
    };
}

export { ScheduledMeetingsEmailsVM };
